<template>
    <div class="privacypolicy">
        <div class="main-wrapper">
            <layout-header></layout-header>
            <layout-sidebar></layout-sidebar>
            <!-- Page Wrapper -->
            <div class="page-wrapper">

                <!-- Page Content -->
                <div class="content container-fluid">

                    <!-- Page Header -->
                    <div class="page-header">
                        <div class="row">
                            <div class="col-sm-12">
                                <h3 class="page-title">Privacy Policy</h3>
                                <ul class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/index">Dashboard</router-link>
                                    </li>
                                    <li class="breadcrumb-item active">Privacy Policy</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- /Page Header -->

                    <div class="row">
                        <div class="col-sm-12">

                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vel sodales mauris.
                                Nunc accumsan mi massa, ut maximus magna ultricies et:</p>
                            <ol>
                                <li>Integer quam odio, ullamcorper id diam in, accumsan convallis libero. Duis at
                                    lacinia urna.</li>
                                <li>Mauris eget turpis sit amet purus pulvinar facilisis at sed lacus.</li>
                                <li>Quisque malesuada volutpat orci, accumsan scelerisque lorem pulvinar vitae.</li>
                                <li>Vestibulum sit amet sem aliquam, vestibulum nisi sed, sodales libero.</li>
                            </ol>

                            <h4>Aenean accumsan aliquam justo, et rhoncus est ullamcorper at</h4>
                            <p>Donec posuere dictum enim, vel sollicitudin orci tincidunt ac. Maecenas mattis ex eu elit
                                tincidunt egestas. Vivamus posuere nunc vel metus bibendum varius. Vestibulum suscipit
                                lacinia eros a aliquam. Sed dapibus arcu eget egestas hendrerit.</p>

                            <p>Vivamus consectetur metus at nulla efficitur mattis. Aenean egestas eu odio vestibulum
                                vestibulum. Duis nulla lectus, lacinia vitae nibh vitae, sagittis interdum lacus. Mauris
                                lacinia leo odio, eget finibus lectus pharetra ut. Nullam in semper enim, id gravida
                                nulla.</p>

                            <p>Fusce gravida auctor justo, vel lobortis sem efficitur id. Cras eu eros vitae justo
                                dictum tempor.</p>

                            <h4>Etiam sed fermentum lectus. Quisque vitae ipsum libero</h4>
                            <p>Phasellus sit amet vehicula arcu. Etiam pulvinar dui libero, vitae fringilla nulla
                                convallis in. Fusce sagittis cursus nisl, at consectetur elit vestibulum vestibulum:</p>
                            <ul>
                                <li>Nunc pulvinar efficitur interdum.</li>
                                <li>Donec feugiat feugiat pulvinar.</li>
                                <li>Suspendisse eu risus feugiat, pellentesque arcu eu, molestie lorem. </li>
                                <li>Duis non leo commodo, euismod ipsum a, feugiat libero.</li>
                            </ul>
                            <h4>pulvinar</h4>
                            <p>Sed sollicitudin, diam nec tristique tincidunt, nulla ligula facilisis nunc, non
                                condimentum tortor leo id ex.</p>

                            <p>Vivamus consectetur metus at nulla efficitur mattis. Aenean egestas eu odio vestibulum
                                vestibulum. Duis nulla lectus, lacinia vitae nibh vitae, sagittis interdum lacus. Mauris
                                lacinia leo odio, eget finibus lectus pharetra ut. Nullam in semper enim, id gravida
                                nulla.</p>

                            <p>Donec posuere dictum enim, vel sollicitudin orci tincidunt ac. Maecenas mattis ex eu elit
                                tincidunt egestas. Vivamus posuere nunc vel metus bibendum varius. Vestibulum suscipit
                                lacinia eros a aliquam. Sed dapibus arcu eget egestas hendrerit.Donec posuere dictum
                                enim, vel sollicitudin orci tincidunt ac. Maecenas mattis ex eu elit tincidunt egestas.
                                Vivamus posuere nunc vel metus bibendum varius. Vestibulum suscipit lacinia eros a
                                aliquam. Sed dapibus arcu eget egestas hendrerit.</p>

                            <h4>efficitur</h4>

                            <p>Fusce gravida auctor justo, vel lobortis sem efficitur id. Cras eu eros vitae justo
                                dictum tempor.</p>

                            <p><strong>Vivamus posuere nunc vel metus bibendum varius. Vestibulum suscipit lacinia eros
                                    a aliquam. Sed dapibus arcu eget egestas hendrerit.Donec posuere dictum enim, vel
                                    sollicitudin orci tincidunt ac.</strong></p>

                        </div>
                    </div>

                </div>
                <!-- /Page Content -->

            </div>
            <!-- /Page Wrapper -->
        </div>
    </div>
</template>

<script>
    import LayoutHeader from '@/components/layouts/Header.vue'
    import LayoutSidebar from '@/components/layouts/Sidebar.vue'
    export default {
        components: {
            LayoutHeader,
            LayoutSidebar,
        },
        name: 'privacypolicy'
    }
</script>


// WEBPACK FOOTER //
// src/components/privacypolicy.vue